import { Provider } from '@angular/core';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import {
    MAT_MOMENT_DATE_ADAPTER_OPTIONS,
    MAT_MOMENT_DATE_FORMATS,
    MomentDateAdapter,
} from '@angular/material-moment-adapter';

/** Configurarea Angular Material (formular, datepicker cu moment, format DD.MM.YYYY). */
export function provideMaterialConfig(): Provider[] {
    return [
        // Legacy Material's underline-only form-field appearance was removed in the MDC-based
        // components; 'fill' was chosen as the closest visual match to the pre-MDC look for this app.
        { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'fill' } },
        { provide: MAT_DATE_LOCALE, useValue: 'ro' },
        { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUTC: true } },
        // MAT_MOMENT_DATE_FORMATS's dateInput uses moment's lowercase 'l' token, which
        // resolves to the *non-zero-padded* form of the locale's short date (e.g.
        // "16.2.1977", not "16.02.1977") - it doesn't match this app's own datepicker
        // hint text ("Format: zz.ll.aaaa") on every field. Hardcode DD.MM.YYYY directly
        // instead of relying on a locale-derived token, so it's guaranteed to match.
        {
            provide: MAT_DATE_FORMATS,
            useValue: {
                ...MAT_MOMENT_DATE_FORMATS,
                parse: { ...MAT_MOMENT_DATE_FORMATS.parse, dateInput: 'DD.MM.YYYY' },
                display: { ...MAT_MOMENT_DATE_FORMATS.display, dateInput: 'DD.MM.YYYY' },
            },
        },
        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS] },
    ];
}

/**
 * Configurarea Material pentru rutele lazy. Serviciile comune (ApiService, SnackBarService etc.)
 * sunt singleton in radacina (`@Service()`), nu mai primesc cate o instanta pe fiecare ruta.
 */
export function provideShared(): Provider[] {
    return provideMaterialConfig();
}
